import { FormulaFields, UserLoop, BundleType } from 'services/store/ai/types';
import { TextPromptData } from './types';

const getTextPromptFormData = (prompt: TextPromptData): FormData => {
  const { text, formula } = prompt;

  const formData = new FormData();
  formData.append('bundle_type', BundleType.TEXT2MUSIC);

  const formattedText = text.replace(/\r?\n/g, ' ');
  formData.append('prompt', formattedText);

  const userLoop = formula.find(
    (item): item is UserLoop => item.field === FormulaFields.UserLoop
  );

  if (userLoop) {
    formData.append('user_audio_id', userLoop.value.loopId);
    formData.append('entropy', userLoop.value.entropy.toString());
  }

  return formData;
};

export default getTextPromptFormData;
